// Public landing page for the Google / Microsoft calendar OAuth popup.
//
// The provider redirects the "Connect" popup here with ?code/?state (or ?error).
// We relay the result back to the opener (Settings' message handler) via
// postMessage and close ourselves. Native Connect uses the same registered
// redirect URI, so when there is no opener we bounce into the app scheme and
// the app exchanges the code.

import { useEffect } from 'react';
import { CalendarCheck } from 'lucide-react';
import { calendarAppCallbackUrl } from '../hooks/calendarNative';

export default function CalendarCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code') || undefined;
    const state = params.get('state') || undefined;
    const error = params.get('error') || params.get('error_description') || undefined;

    const payload = error
      ? { type: 'calendar-oauth' as const, error }
      : { type: 'calendar-oauth' as const, code, state };

    if (window.opener) {
      window.opener.postMessage(payload, window.location.origin);
      window.close();
      return;
    }

    if (state) {
      window.location.replace(calendarAppCallbackUrl({ state, code, error }));
    }
  }, []);

  return (
    <div className="min-h-screen bg-off-white flex items-center justify-center px-4">
      <div className="bg-white rounded-2xl shadow-sm p-8 text-center max-w-sm">
        <CalendarCheck size={28} className="text-navy mx-auto mb-3" />
        <p className="text-sm text-gray-600">Returning to Iron Forums…</p>
      </div>
    </div>
  );
}
